import React from 'react';
import clsx from 'clsx';
import { states } from '@/constants/lifecycle';
import IconButton from '@/components/buttons/IconButton';
import { claimStateWithPermissions } from '../state/state';
import Events from '../hooks/events';

const TaskClaimButton = ({
  basic,
  circular,
  iconOnly,
  category,
  className,
  claimStatus,
  disabled,
  silent,
  size,
  task,
}) => {
  const onClick = Events.useClaimRequestTask(category, task);
  const { claimed } = claimStateWithPermissions(task);
  return (
    <>
      <IconButton
        basic={basic}
        circular={circular}
        className={clsx('aridhia-task-claim-button', className)}
        disabled={disabled || claimStatus === states.PENDING}
        iconName={claimed ? 'remove user' : 'add user'}
        iconOnly={iconOnly}
        labelPosition="left"
        messageId={claimed ? 'actions.unclaim' : 'actions.claim'}
        loading={claimStatus === states.PENDING}
        onClick={() => onClick({ ...task, silent })}
        size={size}
      />
    </>
  );
};

export default TaskClaimButton;
